// -- Imports -- //
require('onbrandutilityfunctions/build/conditional-babel-polyfill.bundle.js'); // use all the things!
const onbrandUtilityFunctions = require('onbrandutilityfunctions');
const devOptions = require('./dev-options.js'); //Development options
const onbrandScss = require('./onbrand.scss'); //Onbrand styles
const clientScss = require('./client/client.scss'); //client styles
const htmlHeader = require('./includes/header.html');
const htmlFooter = require('./includes/footer.html');
const { handleExternalLinks } = require('./modules/handleExternalLinks');

require('./modules/handlePageType');
const dispatchPageFunctions = require('./modules/dispatchPageActions');
const handleTileUpdates = require('./modules/handleTileUpdates');
const handleClientHeader = require('./modules/handleClientHeader');

module.exports = {
  initOnbrand: function initOnbrand(translations, production) {
    // -- Startup -- //
    production ? null : onbrandUtilityFunctions.devMode(devOptions);
    $('body').prepend(htmlHeader(translations));
    $('body').append(htmlFooter(translations));
    window.onbrandLoaded = false;

    // old time embed error throw "fix" (TODO: make this better)
    onbrandUtilityFunctions.legacyEmbedTileFix();
    // Remove the "touch" class on touchscreen laptops
    onbrandUtilityFunctions.removeTouchForLaptops();
    // Remove the hub function updateOverlaySize
    onbrandUtilityFunctions.overrideHubFuctions();
    // Adds body classes for content type (blogPost, youtube, sales-stream etc)
    onbrandUtilityFunctions.helpfulClasses();
    // Rebuild the share widget for the top-nav
    onbrandUtilityFunctions.fixShareWidgetImproved();
    // warns you if your query string is missing.
    onbrandUtilityFunctions.noQueryStringSafeguard();
    // makes the reco engine sticky to the target / top of screen
    onbrandUtilityFunctions.recoEnginePositioning('.top-nav');

    // Bandaid fix for persistant loading icon on mobile

    // -- Hub Events -- //
    Hubs.Events.on('load', () => {
      if (!window.onbrandLoaded) {
        // Add your onloads here...
        onbrandUtilityFunctions.blockCtaFix();
        onbrandUtilityFunctions.fadeOutItem();
        handleClientHeader();
        dispatchPageFunctions();
        handleTileUpdates();
        handleExternalLinks();
        // end your onloads before here...
        window.onbrandLoaded = true;
      }
    })
      .on('itemsLoaded', (itemIds, selectors) => {
        handleTileUpdates();
        // handleExternalLinks();
      })
      .on('resize', () => {
        // adjust side cta or addThis by passing a number into the function
        // eg onbrandUtilityFunctions.sideCtaFix(150); will push the side cta down by 150px, do the same for on scroll
        onbrandUtilityFunctions.sideCtaFix();
        onbrandUtilityFunctions.addThisFix();
      })
      .on('scroll', () => {
        onbrandUtilityFunctions.sideCtaFix();
        onbrandUtilityFunctions.addThisFix();
        onbrandUtilityFunctions.blockCtaFix();
        onbrandUtilityFunctions.fadeOutItem();
      })
      .on('ctaActivate', (ctaId) => { }) //eslint-disable-line no-unused-vars
      .on('ctaFormSubmitSuccess', (ctaId, mappedData, ctaName) => { }); //eslint-disable-line no-unused-vars

    // The new hub events can trigger before cihost scripts are loaded.
    // This will ensure your scripts fire no matter what, but not more than once for 'load'.
    if (!window.onbrandLoaded) {
      Hubs.Events.trigger('load');
    }
  },
};



// WEBPACK FOOTER //
// ./onbrand.js